<template>
  <div class="">
    <input class="text-base font-mono p-2" list="suggestions" type="search" placeholder="Search" v-model="term">
    <datalist id="suggestions">
      <option :value="path.v" :key="path.v" v-for="path in filteredPaths"/>
    </datalist>
  </div>
</template>


<script>
 import Fuse from 'fuse.js'
 import {mapState} from 'vuex';
 export default {
   props: {
     value: {
       type: String,
       default: ''
     }
   },

   data () {
     return {
       term: this.value
     }
   },

   computed: {
     ...mapState({
       paths: state => state.pathsList.map(v => ({v}))
     }),

     filteredPaths() {
       const fuse = new Fuse(this.paths, {
         includeScore: true,
         shouldSort: true,
         keys: [
           'v'
         ]
       });

       return fuse.search(this.term)
                  .map(i => i.item);
     }
   },
   components: { },
   methods: {
     entitySearch (input) {
       this.$emit('input', input);

       return this.paths.filter(p => {
         return p.startsWith(input);
       })
     },

     submitSelect (input)  {
       this.term = input;
     }
   },

   watch: {
     term (to) {
       this.$emit('input', to);
     }
   }
 };
</script>
